<ng-container *uiModalTitle>
  {{ "create_objective" | localize }}
  <div class="create-okr-subtitle">
    {{ "all_required_fields_are_marked_with_an_asterisk" | localize }}
  </div>
</ng-container>
<form-group>
  <session-form-item
    [value]="sessionId"
    [labelText]="'session' | localize"
    [placeholder]="'search_for_session' | localize"
    [required]="true"
    e2eTestId="session-selector-dropdown"
    controlName="sessionId"></session-form-item>
  <text-form-item
    [labelText]="'title' | localize"
    [placeholder]="'enter_your_objective' | localize"
    [maxCharsCount]="okrNameMaxCharsCount"
    [required]="true"
    [validators]="okrNameValidators"
    e2eTestId="enter-objective-name"
    controlName="name"></text-form-item>
</form-group>
